import React from "react";

import CartaoGrafico from "./CartaoGrafico";
import { TabelaSituacao } from "./LotesSituacao";
import useResumoDespacho from "./useResumoDespacho";

// Situação das coletas no período (PO1-3494): solicitadas, com falha e lotes
// despachados sem pedido de coleta. Mesma tabela de números do card de Lotes.

export function linhasColetas(coletas) {
  if (!coletas) return [];
  return [
    { rotulo: "Solicitadas", valor: coletas.solicitadas, destaque: true },
    { rotulo: "Com falha", valor: coletas.falhas },
    { rotulo: "Despachados sem coleta", valor: coletas.despachadosSemColeta },
  ];
}

export default function ColetasSituacao({ deferLoad = false, onRegisterFetch }) {
  const { dados, carregando, erro } = useResumoDespacho({ deferLoad, onRegisterFetch });
  const linhas = linhasColetas(dados && dados.coletas);

  return (
    <CartaoGrafico titulo="Coletas" subtitulo="Pedidos de coleta dos lotes despachados no período" carregando={carregando} erro={erro} vazio={!linhas.length}>
      <TabelaSituacao linhas={linhas} ariaLabel="Situação das coletas" />
    </CartaoGrafico>
  );
}
